var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:[
		( _obj = {
			formatBullet: _vm.formatBullet,
			large: _vm.large
		}, _obj[_vm.contentClass] = _vm.contentClass, _obj.noEventClick = !_vm.handleClickEvent, _obj.active = _vm.isActive, _obj ) ],attrs:{"close":_vm.close,"close-icon":"mdi-close","color":_vm.color,"text-color":_vm.textColor,"small":_vm.small},on:{"click:close":function($event){return _vm.$emit('click:close')},"click":function($event){return _vm.$emit('click')}}},[(_vm.interactiveTag)?_c('div',{staticClass:"container-content-chip"},[_vm._t("default"),_c('v-icon',{staticClass:"ml-2"},[_vm._v("mdi-dots-horizontal")])],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }